import React, { useState, useRef, useEffect, useCallback } from "react";
import { useSelector } from "react-redux";
// import EmotionalAnalysisChart from "../Components/EmotionalAnalysisChart";
// import { Link } from "react-router-dom";
import ArrowIcon from "../Assets/arrow_up.svg";
import arrow from "../Assets/arrowIcon.svg";
import useRouteFunctions from "../Hooks/Routes/useRouteFunctions";
import { useNavigate } from "react-router-dom";
import { Loader } from '../constents/components.js';
import useFetchMockDetail from "../Hooks/mockInterview/useFetchMockDetail.js";
// import AnswerCartOfQuestion from "../Components/InterviewSummary/AnswerCartOfQuestion";
// import { Loader } from '../../constents/components.js';



const EmotionalAnalysisChart = ({
  summary,
  candidateResult = {},
  avg_score,
}) => {
  const CANDIDATE_NAME = candidateResult?.Name;
  const CANDIDATE_EMAIL = candidateResult?.Email;
  const CANDIDATE_PROFILE_IMG = candidateResult?.Profile_Url;
  const CANDIDATE_OVERALL_SUMMARY = summary;
  const [showFullText, setShowFullText] = useState(false);

  // ------------ for Profile Image and Name and score
  //<div className="flex gap-4 items-end">
  //     <div className="flex gap-2 flex-1">
  //         {/* for img and name */}
  //         {CANDIDATE_PROFILE_IMG && <div className="grid place-content-center"> <img src={CANDIDATE_PROFILE_IMG} alt="Candidate Profile Image" className=" w-12 aspect-square rounded-full" /></div>}
  //         <div className="flex flex-col gap-">
  //             <p className="text-lg">{CANDIDATE_NAME}</p>
  //             <span className="text-xs">{CANDIDATE_EMAIL}</span>
  //         </div>
  //     </div>
  //     <div>
  //         {/* for score */}
  //         {![undefined, null, NaN].includes(CANDIDATE_AVG_SCORE) && <p className="text-primary-color-900"><span className="text-3xl font-semibold">{CANDIDATE_AVG_SCORE}</span>/10</p>}
  //     </div>
  // </div>
  return (
    <div className=" bg-white rounded-xl relative w-full max-w-2xl mx-auto p-2 md:p-4 lg:p-4  ">
      <h2 className="font-medium text-2xl mb-4">Total Score: <span className="text-primary-color-900">
        <span className="text-3xl font-semibold">
          {parseFloat(avg_score.toFixed(2)).toString()}
        </span>
        /10
      </span></h2>

      

      <div className="mt-4 text-left text-gray-700">
        
        <p className="items-center">
          <span className="font-bold">AI Evaluation Summary:- </span>
          {showFullText
            ? CANDIDATE_OVERALL_SUMMARY
            : `${CANDIDATE_OVERALL_SUMMARY?.slice(0, 200)}...`}
          <button
            onClick={() => setShowFullText(!showFullText)}
            className="text-blue-500 hover:text-blue-700 ml-2 cursor-pointer font-medium"
          >
            {showFullText ? "see less" : "see more"}
          </button>
        </p>
      </div>
    </div>
  );
};

const AnswerCartOfQuestion = ({ current, questionNumber, heightToSkip }) => {
  const [expandedAnswer, setExpandedAnswer] = useState(false);
  const [expandedAnalysis, setExpandedAnalysis] = useState(false);

  const SCORE = Math.round(current?.score > 10 ? 10 : current?.score);
  const REASON = current?.reason || "No reason provided";
  const ANSWER = current?.candidate || "No answer provided";
  const QUESTION = current?.question || "No question provided";

  return (
    <div
      className="bg-white p-6 rounded-xl flex-1 overflow-auto "
      style={{ maxHeight: `calc(100vh - ${heightToSkip}px)` }}
    >
      <h2 className=" text-xl mb-4">Question {questionNumber}</h2>
      <div className="bg-box-bg  rounded-xl mb-6">
        <p className="text-black font-semibold">{QUESTION}</p>
      </div>

      {/* Candidate's Answer */}
      <div className="mb-6">
        <h3 className="font-medium mb-3">Your Answer</h3>
        <div className="bg-box-bg rounded-xl mb-4">
          <p className="text-sm text-black">
            {expandedAnswer ? ANSWER : `${ANSWER?.substring(0, 150)}...`}
            <span
              className="text-blue-500 ml-1 font-light cursor-pointer"
              onClick={() => setExpandedAnswer(!expandedAnswer)}
            >
              {expandedAnswer ? "Read Less" : "Read More"}
            </span>
          </p>
        </div>
      </div>

      {/* Answer Score & Reason */}
      <div className="mb-6">
        <div className="flex justify-between gap-4">
          <div className="flex items-center gap-4 mb-4">
            <div>
              <div className="w-16 h-16 rounded-full flex items-center justify-center text-white font-bold bg-primary-color-900">
                {SCORE}/10
              </div>
              <h2 className="text-text-color-strong text-sm text-center">
                Score
              </h2>
              <span className="text-text-color-strong text-sm"></span>
            </div>
          </div>
        </div>
        
        <h3 className=" font-medium mb-3 items-center"><span className=" text-xl mb-4">Q{questionNumber}</span> AI Evaluation summary</h3>
        <p className="text-text-color-strong text-sm">{REASON}</p>
      </div>
    </div>
  );
};

const MockReview = () => {
  const [loading, error, fetchMockDetail] = useFetchMockDetail();
  const mockId = new URLSearchParams(window.location.search).get("mock_id");
  const mockExists = useSelector(state => !!state?.mocks?.[mockId]?.evaluation_results);
  useEffect(() => { if (!mockExists) fetchMockDetail(mockId); }, [mockId]);
  
  const mockSummary = useSelector(
    (state) => state?.mocks?.[mockId]?.overall_summary
  );
  const mockResults = useSelector((state) =>
    Object.values(state?.mocks?.[mockId]?.evaluation_results ?? {})
  );
  const avg_score = useCallback(() => {
  if (!mockResults || mockResults.length === 0) {
    return 0;
  }
  const totalScore = mockResults.reduce((sum, item) => {
    const score = item?.score;
    return typeof score === "number" ? sum + score : sum;
  }, 0);
  const avg = totalScore / mockResults.length;
  return avg > 10 ? 10 : avg;
}, [mockResults])();
  // console.log("mock result ", mockResults);
  // console.log("mock summary", mockSummary);
  // console.log("avg score", avg_score);
  const questions = useSelector((state) =>
    Object.values(state?.mocks?.[mockId]?.questions ?? {})
  );

  
  //     // if (!review) {
  //     //     return <div>Loading review...</div>;
  //     // }

  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [expandedAnswer, setExpandedAnswer] = useState(false);
  const [expandedAnalysis, setExpandedAnalysis] = useState(false);

  //     // Filter questions from the result

  //     const notToInclude = ['Overall_Reason', 'Total_Score', 'Overall_Emotional_Analysis'];
  //     const questions = Object.entries(candidateResult?.Score || {}).filter(
  //         ([key]) => !notToInclude.includes(key)
  //     );
  //     // Handle question navigation
  const navigate = useNavigate();
  const handleNextQuestion = () => {
    if (currentQuestionIndex < questions.length - 1) {
      setCurrentQuestionIndex(currentQuestionIndex + 1);
      setExpandedAnswer(false);
      setExpandedAnalysis(false);
    }
  };

  const handlePrevQuestion = () => {
    if (currentQuestionIndex > 0) {
      setCurrentQuestionIndex(currentQuestionIndex - 1);
      setExpandedAnswer(false);
      setExpandedAnalysis(false);
    }
  };

  const questionNumber = currentQuestionIndex + 1;
  const totalQuestions = questions.length;
  const { goToDashboardPage } = useRouteFunctions();

  const one = useRef();
  const two = useRef();
  const [maxHeight, setHeight] = useState(32);
  useEffect(() => {
    // console.log(one?.current?.clientHeight);
    // console.log(two?.current?.clientHeight);
    setHeight(
      (pre) => pre + one?.current?.clientHeight + two?.current?.clientHeight
    );
  }, []);

  //     // console.log(maxHeight);

  const BackButton = ({ setState }) => (
    <img
      src={ArrowIcon}
      className="w-4 -rotate-90 cursor-pointer fill-black"
      onClick={() => setState()}
      alt="arrow icon"
    />
  );

  return (
    loading ? <Loader /> :
    <div className="">
      {/* Desktop Layout - Visible on large screens, hidden on mobile */}
      {/* 
                <div ref={one} className='hidden lg:flex items-center gap-2 pl-1 pt-2 pb-5'>
                    <p className='cursor-pointer text-text-color' onClick={() => navigate('/dashboard')}>Dashboard</p>
                    <img
                        src={ArrowIcon}
                        className='w-4 rotate-90 cursor-pointer fill-black'
                        alt='back'
                    />
                    <Link to={routeOfCandidatesAndFullJobPage({ jobId: jobId, type: pageType, view: 'Job Description' })}><span className=' text-text-color'>Job Details</span></Link>
                    <img
                        src={ArrowIcon}
                        className='w-4 rotate-90  fill-black'
                        alt='back'
                    />
                    <Link to={routeOfCandidatesAndFullJobPage({ jobId: jobId, type: pageType, view: 'Candidates' })}><span className=' text-text-color'>Candidates</span></Link>
                    <img
                        src={ArrowIcon}
                        className='w-4 rotate-90  fill-black'
                        alt='back'
                    />
                    <p className=''>Interview Summary</p>
                </div> */}

      <div
        ref={two}
        className="items-center gap-2 pb-4 hidden lg:flex flex-col lg:flex-row"
      >
        <div className="rounded-full bg-white border border-input-box-border border-solid h-6 w-6 flex items-center justify-center">
          <BackButton setState={() => navigate(-1)} />
        </div>
        <h1 className="text-xl md:hidden lg:hidden">Question Summary</h1>
        <h1 className="text-xl hidden md:block lg:block md:text-3xl lg:text-3xl">
          Interview Question Summary
        </h1>
      </div>

      <div className="hidden lg:flex flex-col lg:flex-row gap-4">
        {/* Left sidebar desktop - Overall Emotional Analysis */}
        <div
          className=" w-1/4 overflow-auto "
          style={{ maxHeight: `calc(100vh - ${maxHeight}px)` }}
        >
          <EmotionalAnalysisChart summary={mockSummary} avg_score={avg_score} />
        </div>
        {/* Left sidebar with question list */}
        <div
          className="bg-white p-4 rounded-xl w-1/8 overflow-auto "
          style={{ maxHeight: `calc(100vh - ${maxHeight}px)` }}
        >
          <div className="flex justify-between items-center mb-4">
            <div className="font-medium">Question ({totalQuestions})</div>
            {/* <button className="rounded-full bg-white border border-input-box-border p-2">
                  <img src={addIconBlack} alt="addIcon" className="w-3 h-3" />
                </button> */}
          </div>

          <div className="flex flex-col gap-3">
            {questions.map((question, index) => (
              <button
                key={index}
                onClick={() => setCurrentQuestionIndex(index)}
                className={`flex items-center p-3 rounded-xl transition-all ${
                  currentQuestionIndex === index
                    ? "bg-light-bg text-primary-color-900 border-[#FF5D0E]"
                    : "bg-white border border-inputbox-border-color text-text-color-strong"
                }`}
              >
                <div
                  className={`w-8 h-8 rounded-full flex items-center justify-center mr-3 ${
                    currentQuestionIndex === index
                      ? "bg-primary-color-900 text-white"
                      : "bg-light-bg text-primary-color-900"
                  }`}
                >
                  {index + 1}
                </div>
                <div className="text-left text-sm truncate">
                  {questions?.[index]?.question?.substring(
                    0,
                    30
                  )}
                  ...
                </div>
              </button>
            ))}
          </div>
        </div>

        <AnswerCartOfQuestion
          questionNumber={questionNumber}
          current={{
            ...questions[currentQuestionIndex],
            ...mockResults[currentQuestionIndex],
          }}
        />
      </div>

      {/* Mobile Layout - Visible on mobile, hidden on large screens */}
      <div className="lg:hidden">
        <div className="flex items-center gap-2 mb-4">
          <div className="rounded-full bg-white border border-input-box-border border-solid h-6 w-6 flex items-center justify-center">
            <BackButton setState={() => goToDashboardPage()} />
          </div>
          <h1 className="text-xl md:text-3xl lg:text-3xl">Question Summary</h1>
        </div>
        <div className="bg-white p-4 rounded-xl">
          <div className="flex justify-between items-center mb-4">
            <div>Question ({totalQuestions})</div>

            {/* <button className="rounded-full bg-white border border-input-box-border p-2">
                  <img src={addIconBlack} alt="addIcon" className="w-3 h-3" />
                </button> */}
          </div>

          {/* Question pagination dots */}
          <div className="flex items-center border rounded-xl justify-between mb-2 relative w-full">
            <div className="flex overflow-x-auto gap-x-2 scrollbar-hide p-2">
              {questions.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentQuestionIndex(index)}
                  className={`w-6 h-6 flex-shrink-0 rounded-full flex items-center text-sm justify-center ${
                    currentQuestionIndex === index
                      ? "bg-light-bg text-primary-color-900"
                      : "bg-question-dots-bg text-text-color-strong"
                  }`}
                >
                  {index + 1}
                </button>
              ))}
            </div>

            <button
              onClick={handlePrevQuestion}
              className="bg-white rounded-full p-2 absolute z-10 left-[-0.5rem]"
            >
              <img src={arrow} alt="arrow" className="h-3 w-3 rotate-180" />
            </button>

            <button
              onClick={handleNextQuestion}
              className="bg-white rounded-full p-2 absolute z-10 right-[-0.5rem]"
            >
              <img src={arrow} alt="arrow" className="h-3 w-3" />
            </button>
          </div>
        </div>

        {/* Question Content */}
        <AnswerCartOfQuestion
          questionNumber={questionNumber}
          current={{
            ...questions[currentQuestionIndex],
            ...mockResults[currentQuestionIndex],
          }}
        />
        {/* Overall Emotional Analysis */}
        <div className="bg-white p-4 mt-2 rounded-xl">
          <EmotionalAnalysisChart
            summary={mockSummary}
            candidateResult={mockResults}
            avg_score={avg_score}
          />
        </div>
      </div>
    </div>
  );
};

export default MockReview;
